import { createContext, useContext, useState } from 'react';
import { FormData, ContextProviderProps } from './interfaces';

interface OriginalDataContextType {
    originalData: FormData | undefined,
    setOriginalData: (val: FormData | undefined) => void
}

export const OriginalDataContext = createContext({} as OriginalDataContextType);
export const useOriginalDataContext = () => useContext(OriginalDataContext);

export const OriginalDataContextProvider = ({ children }: ContextProviderProps) => {
    const [originalData, setOriginalData] = useState<FormData>();
    return <OriginalDataContext.Provider value={{ originalData, setOriginalData }}>
        {children}
    </OriginalDataContext.Provider>
};

